export const handleKeyDown = (event) => {
    if (event.key === " ") {
      event.preventDefault(); // Prevent space input
    }
  }

export const allowOnlyNumeric = (event ) =>{
      const allowedKeys = [
        "Backspace",
        "Delete",
        "Tab",
        "Escape",
        "Enter",
        "ArrowLeft",
        "ArrowRight",
        "ArrowUp",
        "ArrowDown",
      ];

      if (
        allowedKeys.includes(event.key) || // Allow navigation/control keys
        (event.key >= "0" && event.key <= "9")
      ) {
        return; // Allow the keypress
      }

      // Prevent anything else
      event.preventDefault();
}

export const allowOnlyAlpha = (event) => {
  const allowedKeys = [
    "Backspace",
    "Delete",
    "Tab",
    "Escape",
    "Enter",
    "ArrowLeft",
    "ArrowRight",
    "ArrowUp",
    "ArrowDown",
  ];

  if (
    allowedKeys.includes(event.key) || // Allow navigation/control keys
    (event.key >= "a" && event.key <= "z") ||
    (event.key >= "A" && event.key <= "Z") 
  ) {
    return; // Allow the keypress
  }

  // Prevent anything else
  event.preventDefault();
};

export const allowOnlyAlphaNumeric = (event) => {
  const allowedKeys = [
    "Backspace",
    "Delete",
    "Tab",
    "Escape",
    "Enter",
    "ArrowLeft",
    "ArrowRight",
    "ArrowUp",
    "ArrowDown",
  ];

  if (
    allowedKeys.includes(event.key) || // Allow navigation/control keys
    (event.key >= "a" && event.key <= "z") ||
    (event.key >= "A" && event.key <= "Z") ||
    (event.key >= "0" && event.key <= "9") 
  ) {
    return; // Allow the keypress
  }

  // Prevent anything else
  event.preventDefault();
};

export const preventLimitEvent = (event,limit = 5000) => {
  // const newValue = parseInt(value + event.key, 10);
  // const newValue = event.target.valueAsNumber
  const newValue = Number(event.target.value)

  // Allow Backspace, Delete, Tab, Enter, and Arrow keys
  if (
    ["Backspace", "Delete", "Tab", "ArrowLeft", "ArrowRight", "Enter"].includes(
      event.key
    )
  ) {
    return;
  }

  // Prevent invalid or out-of-limit inputs
  if (newValue >= 5000) {
    event.preventDefault();
  }
};